import statisticsApi from '../../api/pvStatistics.api';

// initial state
const state = {
  receiptsByYear: [],
  receiptsByYearTotal: 0,
  activationsByYear: [],
  activationsByYearTotal: 0,
  activationsLivePerMonth: null,
  activationModules: [],
  twilioExpensesPerMonth: null,
  receiptsPerActivation: [],
  receiptsPerActivationTotal: 0,
  companyReceiptsOverview: null,
  companyCashbacksByMarket: null,
  companyVerifiedCashbacksByMarket: null,
  companyReceiptsByItemMatch: null,
  companyItemMatchesByMarket: null,
  companyStatusesByMarket: null,
  companyReceiptsByRetailer: null,
  companyMarkets: [],
  companyReceiptsWeeklyByMarket: null,
  companyCampaigns: [],
  offerPageViews: null,
  offerPageViewsWeekly: null,
  statisticsStatus: '',
};

// getters
const getters = {
  receiptsByYear: state => state.receiptsByYear,
  receiptsByYearTotal: state => state.receiptsByYearTotal,
  activationsByYear: state => state.activationsByYear,
  activationsByYearTotal: state => state.activationsByYearTotal,
  activationsLivePerMonth: state => state.activationsLivePerMonth,
  activationModules: state => state.activationModules,
  twilioExpensesPerMonth: state => state.twilioExpensesPerMonth,
  receiptsPerActivation: state => state.receiptsPerActivation,
  receiptsPerActivationTotal: state => state.receiptsPerActivationTotal,
  companyReceiptsOverview: state => state.companyReceiptsOverview,
  companyCashbacksByMarket: state => state.companyCashbacksByMarket,
  companyVerifiedCashbacksByMarket: state => state.companyVerifiedCashbacksByMarket,
  companyReceiptsByItemMatch: state => state.companyReceiptsByItemMatch,
  companyItemMatchesByMarket: state => state.companyItemMatchesByMarket,
  companyStatusesByMarket: state => state.companyStatusesByMarket,
  companyReceiptsByRetailer: state => state.companyReceiptsByRetailer,
  companyMarkets: state => state.companyMarkets,
  companyReceiptsWeeklyByMarket: state => state.companyReceiptsWeeklyByMarket,
  companyCampaigns: state => state.companyCampaigns,
  offerPageViews: state => state.offerPageViews,
  offerPageViewsWeekly: state => state.offerPageViewsWeekly,
  statisticsStatus: state => state.statisticsStatus,
};

// actions
const actions = {
  getReceiptsByYear({ commit }, payload) {
    commit('STATISTICS_STATUS', 'LOADING');
    return statisticsApi.getReceiptsByYear(payload)
      .then((response) => {
        commit('RECEIPTS_BY_YEAR', response);
        commit('STATISTICS_STATUS', 'FINISHED');
      });
  },

  getActivationsByYear({ commit }, payload) {
    commit('STATISTICS_STATUS', 'LOADING');
    return statisticsApi.getActivationsByYear(payload)
      .then((response) => {
        commit('ACTIVATIONS_BY_YEAR', response);
        commit('STATISTICS_STATUS', 'FINISHED');
      });
  },

  getActivationsLivePerMonth({ commit }, payload) {
    commit('STATISTICS_STATUS', 'LOADING');
    return statisticsApi.getActivationsLivePerMonth(payload)
      .then((response) => {
        commit('ACTIVATIONS_LIVE_PER_MONTH', response);
        commit('STATISTICS_STATUS', 'FINISHED');
      });
  },

  getActivationModules({ commit }, payload) {
    commit('STATISTICS_STATUS', 'LOADING');
    return statisticsApi.getActivationModules(payload)
      .then((response) => {
        commit('ACTIVATION_MODULES', response.modules);
        commit('STATISTICS_STATUS', 'FINISHED');
      });
  },

  getExpensesPerMonth({ commit }, payload) {
    commit('STATISTICS_STATUS', 'LOADING');
    return statisticsApi.getExpensesPerMonth(payload)
      .then((response) => {
        commit('TWILIO_EXPENSES_PER_MONTH', response);
        commit('STATISTICS_STATUS', 'FINISHED');
      });
  },

  getReceiptsPerActivation({ commit }, payload) {
    commit('STATISTICS_STATUS', 'LOADING');
    return statisticsApi.getReceiptsPerActivation(payload)
      .then((response) => {
        commit('RECEIPTS_PER_ACTIVATION', response);
        commit('STATISTICS_STATUS', 'FINISHED');
      });
  },

  getCompanyReceiptsOverview({ commit }, payload) {
    commit('STATISTICS_STATUS', 'LOADING');
    return statisticsApi.getCompanyReceiptsOverview(payload)
      .then((response) => {
        commit('COMPANY_RECEIPTS_OVERVIEW', response);
        commit('STATISTICS_STATUS', 'FINISHED');
      });
  },

  getCompanyCashbacksByMarket({ commit }, payload) {
    commit('STATISTICS_STATUS', 'LOADING');
    return statisticsApi.getCompanyCashbacksByMarket({ ...payload, success: true, done: true })
      .then((response) => {
        commit('COMPANY_CASHBACKS_BY_MARKET', response);
        commit('STATISTICS_STATUS', 'FINISHED');
      });
  },

  getCompanyVerifiedCashbacksByMarket({ commit }, payload) {
    commit('STATISTICS_STATUS', 'LOADING');
    return statisticsApi.getCompanyCashbacksByMarket({ ...payload, success: true })
      .then((response) => {
        commit('COMPANY_VERIFIED_CASHBACKS_BY_MARKET', response);
        commit('STATISTICS_STATUS', 'FINISHED');
      });
  },

  getCompanyItemMatchesByMarket({ commit }, payload) {
    commit('STATISTICS_STATUS', 'LOADING');
    return statisticsApi.getCompanyItemMatchesByMarket(payload)
      .then((response) => {
        commit('COMPANY_ITEM_MATCHES_BY_MARKET', response);
        commit('STATISTICS_STATUS', 'FINISHED');
      });
  },

  getCompanyStatusesByMarket({ commit }, payload) {
    commit('STATISTICS_STATUS', 'LOADING');
    return statisticsApi.getCompanyStatusesByMarket(payload)
      .then((response) => {
        commit('COMPANY_STATUSES_BY_MARKET', response);
        commit('STATISTICS_STATUS', 'FINISHED');
      });
  },

  getCompanyReceiptsByItemMatch({ commit }, payload) {
    commit('STATISTICS_STATUS', 'LOADING');
    return statisticsApi.getCompanyReceiptsByItemMatch(payload)
      .then((response) => {
        commit('COMPANY_RECEIPTS_BY_ITEM_MATCH', response);
        commit('STATISTICS_STATUS', 'FINISHED');
      });
  },

  getCompanyReceiptsByRetailer({ commit }, payload) {
    commit('STATISTICS_STATUS', 'LOADING');
    return statisticsApi.getCompanyReceiptsByRetailer(payload)
      .then((response) => {
        commit('COMPANY_RECEIPTS_BY_RETAILER', response);
        commit('STATISTICS_STATUS', 'FINISHED');
      });
  },

  getCompanyMarkets({ commit }, payload) {
    return statisticsApi.getCompanyMarkets(payload)
      .then((response) => {
        commit('COMPANY_MARKETS', response.markets);
      });
  },

  getCompanyReceiptsWeeklyByMarket({ commit }, payload) {
    commit('STATISTICS_STATUS', 'LOADING');
    return statisticsApi.getCompanyReceiptsWeeklyByMarket(payload)
      .then((response) => {
        commit('COMPANY_RECEIPTS_WEEKLY_BY_MARKET', response);
        commit('STATISTICS_STATUS', 'FINISHED');
      });
  },

  getCompanyCampaigns({ commit }, payload) {
    return statisticsApi.getCompanyCampaigns(payload)
      .then((response) => {
        commit('COMPANY_CAMPAIGNS', response.campaigns);
      });
  },

  getOfferPageViews({ commit }, payload) {
    commit('STATISTICS_STATUS', 'LOADING');
    return statisticsApi.getOfferPageViews(payload)
      .then((response) => {
        commit('OFFER_PAGE_VIEWS', response.rows);
        commit('STATISTICS_STATUS', 'FINISHED');
      });
  },

  getOfferPageViewsWeekly({ commit }, payload) {
    commit('STATISTICS_STATUS', 'LOADING');
    return statisticsApi.getOfferPageViewsWeekly(payload)
      .then((response) => {
        commit('OFFER_PAGE_VIEWS_WEEKLY', response);
        commit('STATISTICS_STATUS', 'FINISHED');
      });
  },
};

// mutations
const mutations = {
  RECEIPTS_BY_YEAR(state, { years, total }) {
    state.receiptsByYear = years;
    state.receiptsByYearTotal = total;
  },
  ACTIVATIONS_BY_YEAR(state, { years, total }) {
    state.activationsByYear = years;
    state.activationsByYearTotal = total;
  },
  ACTIVATIONS_LIVE_PER_MONTH(state, activationsLivePerMonth) {
    state.activationsLivePerMonth = activationsLivePerMonth;
  },
  ACTIVATION_MODULES(state, activationModules) {
    state.activationModules = activationModules;
  },
  TWILIO_EXPENSES_PER_MONTH(state, twilioExpensesPerMonth) {
    state.twilioExpensesPerMonth = twilioExpensesPerMonth;
  },
  RECEIPTS_PER_ACTIVATION(state, { activations, total }) {
    state.receiptsPerActivation = activations;
    state.receiptsPerActivationTotal = total;
  },
  COMPANY_RECEIPTS_OVERVIEW(state, overview) {
    state.companyReceiptsOverview = overview;
  },
  COMPANY_CASHBACKS_BY_MARKET(state, cashbacksByMarket) {
    state.companyCashbacksByMarket = cashbacksByMarket;
  },
  COMPANY_VERIFIED_CASHBACKS_BY_MARKET(state, cashbacksByMarket) {
    state.companyVerifiedCashbacksByMarket = cashbacksByMarket;
  },
  COMPANY_ITEM_MATCHES_BY_MARKET(state, itemMatchesByMarket) {
    state.companyItemMatchesByMarket = itemMatchesByMarket;
  },
  COMPANY_STATUSES_BY_MARKET(state, statusesByMarket) {
    state.companyStatusesByMarket = statusesByMarket;
  },
  COMPANY_RECEIPTS_BY_ITEM_MATCH(state, receiptsByItemMatch) {
    state.companyReceiptsByItemMatch = receiptsByItemMatch;
  },
  COMPANY_RECEIPTS_BY_RETAILER(state, receiptsByRetailer) {
    state.companyReceiptsByRetailer = receiptsByRetailer;
  },
  COMPANY_MARKETS(state, markets) {
    state.companyMarkets = markets;
  },
  COMPANY_RECEIPTS_WEEKLY_BY_MARKET(state, weeklyByMarket) {
    state.companyReceiptsWeeklyByMarket = weeklyByMarket;
  },
  COMPANY_CAMPAIGNS(state, campaigns) {
    state.companyCampaigns = campaigns;
  },
  OFFER_PAGE_VIEWS(state, offerPageViews) {
    state.offerPageViews = offerPageViews;
  },
  OFFER_PAGE_VIEWS_WEEKLY(state, offerPageViewsWeekly) {
    state.offerPageViewsWeekly = offerPageViewsWeekly;
  },
  STATISTICS_STATUS(state, status) {
    state.statisticsStatus = status;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
